import { Box, Flex } from '@radix-ui/themes';
import { useLocation } from 'react-router-dom';

import { AdminSideBar } from 'admin/elements/side-bar';
import APNavBar from 'Components/adminpanel/Elements/APNavBar';
import {
   CreateResumeMode,
   FeatureCreateResume,
   ResumeHeader,
} from 'candidate/feature-create-resume';

import './admin-edit-resume.scss';

export const FeatureAdminEditResume = () => {
   const location = useLocation();

   return (
      <>
         <APNavBar />
         <Box pt="80px" className="admin-edit-resume">
            <Flex width="270px" minWidth="270px">
               <AdminSideBar />
            </Flex>

            <Box className="admin-edit-resume__content" p="6">
               <Flex direction="column" flexGrow="1" gap="4">
                  <ResumeHeader mode={CreateResumeMode.ADMIN_EDIT} />
                  <FeatureCreateResume
                     mode={CreateResumeMode.ADMIN_EDIT}
                     submitSuccessPath={`/admin/resumes${location.search}`}
                  />
               </Flex>
            </Box>
         </Box>
      </>
   );
};
